<template>
  <v-container>
    <v-row no-gutters>
      <v-col>
        <UsersTable></UsersTable>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UsersTable from "./tables/UsersTable.vue";
export default {
  name: "Benutzer",
  components: {
    UsersTable,
  },
  data() {
    return {
      msg: "Benutzer",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
